package org.multiplatform.kotfolio.pages.flutter

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("/flutter/questions")
@Composable
fun QuestionsPage() {
    BlogLayout(
        PageProperties(
            "Interview Questions",
            "First most comprehensive Flutter Interview Questions here we discuss questions regarding all aspects that are mostly asked Fresher and Experience in Flutter/Dart Interviews."
        ),
        BlogProperties("Flutter", "Interview Questions")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            Ol {
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Is Dart compiled or interpreted language?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Dart is a unique language in that it can function as both a compiled and an interpreted language, depending on the context of its use.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Ahead-of-Time (AOT) Compilation",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "In production environments, particularly for Flutter apps, Dart is compiled Ahead-of-Time. This means the code is compiled into native code for the respective platforms (like iOS and Android) before execution.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "This approach ensures optimal performance and quicker startup times, which is crucial for mobile applications.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Just-in-Time (JIT) Compilation",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "During development, Dart often employs Just-in-Time (JIT) compilation. This allows developers to see their changes almost instantaneously (known as hot reload). JIT compilation compiles the code as it runs, facilitating a faster and more dynamic",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How does Dart AOT work?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The AOT-compiled code runs inside an efficient Dart runtime that enforces the sound Dart type system and manages memory using fast object allocation and a generational garbage collector.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How to create private variables in Dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "In dart ‘_’ is used before the variable name to declare it as private. Unlike other programming languages, here private doesn’t mean it is available only to the class it is in, private means it is accessible in the file it is in and not accessible to other files.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the late keyword used for?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "We use the late keyword to declare variables that will be initialized later point in time.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a Null Aware Operator?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Null-aware operators in dart allow you to make computations based on whether or not a value is null. It’s shorthand for longer expressions. A null-aware operator is a nice tool for making nullable types usable in Dart instead of throwing an error.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The most common use of the Null aware operator is when a developer wants to parse JSON data from the server and after parsing JSON, the user can check whether the JSON is empty or not using the IF-Else condition.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is Lazy Loading?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Lazy loading is a design pattern commonly used in computer programming and mostly in web design and development to defer the initialization of an object until the point at which it is needed. It can contribute to efficiency in the program’s operation if properly and appropriately used.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The most common use of the Null aware operator is when a developer wants to parse JSON data from the server and after parsing JSON, the user can check whether the JSON is empty or not using the IF-Else condition.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain singleton class in flutter.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "In Flutter, a singleton class is a class that allows only a single instance of itself to be created, and provides a global point of access to that instance. Singleton classes are used to represent global state or resources that are shared by multiple parts of an application.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "To create a singleton class in Flutter, you can use the singleton pattern, which involves creating a private constructor and a static method that returns the single instance of the class.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = """
                             class MySingletonClass {
                               static final MySingletonClass _instance = MySingletonClass._internal();
                               factory MySingletonClass() {
                               return _instance;
                             }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is Factory constructors?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A factory constructor is a constructor that can be used when you don’t necessarily want a constructor to create a new instance of your class.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This might be useful if you hold instances of your class in memory and don’t want to create a new one each time (or if the operation of creating an instance is costly).",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Another use case is if you have certain logic in your constructor to initialize a final field that cannot be done in the initializer list.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do Object, dynamic, and var differ in Dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Object is the root class for all Dart classes, allowing a variable to hold any type of value but requires explicit casting for most operations.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "dynamic is a type that bypasses static type checking, offering flexibility at the cost of forgoing some compile-time checks.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "var is a keyword used to declare a variable without specifying its type. Dart determines and fixes the variable’s type based on its initial value at compile-time.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What “is” and “as” keywords in dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "is keyword is used to check variable data type whereas “as” keyword is used to give alias name.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = """
                            //is
                            void main() {
                              dynamic a="test";
                              if(a is String){
                                print("string");
                              }
                            }
                            
                            //as
                            import 'package:flutter/material.dart' as material;
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Inheritance Vs Composition in dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Inheritance represents an “is-a” relationship, where one class inherits the properties and behaviors of another class.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Composition represents a “has-a” relationship, where one class contains an instance of another class as a member.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is “mixin”? When do we use it?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Mixins are very helpful when we want to share behavior across multiple classes that don’t share the same class hierarchy, or when it doesn’t make sense to implement such behavior in a superclass.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are mixins and why do we use them in filters?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The mixins, my friend, are simply a class that has functions and we can use them in more than one class such as inheritance.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the use of Mixins?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Multiple inheritances are not supported by Dart. Thus, we need mixins to implement multiple inheritances in Flutter/Dart.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Mixins are a programming concept that allows the reuse of code in a modular and flexible way. They are used to encapsulate and distribute functionalities in a way that a class can include or “mix in” the behavior of the mixin without inheriting from it. Mixins promote code reuse, modular design, and can be especially useful in languages that do not support multiple inheritance.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is AutomaticKeepAliveClientMixin?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Used to automatically keep the state of a widget alive even if it is not visible on the screen. When a widget is removed from the screen due to scrolling or navigation, its state is usually lost. However, some widgets, such as those containing text fields or forms, may need to keep their state even when they are not visible. The AutomaticKeepAliveClientMixin can be used in such cases to ensure that the state of the widget is preserved. To use the AutomaticKeepAliveClientMixin, a widget must implement the wantKeepAlive method, which returns a boolean value indicating whether the widget's state should be kept alive. When this method returns true, the state of the widget will be preserved even when it is not visible. In the next example, the _MyWidgetState class extends the State class and also includes the AutomaticKeepAliveClientMixin. The wantKeepAlive method is overridden to return true, indicating that the widget's state should be kept alive. The super.build(context) method call is also required to ensure that the mixin is properly initialized.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why should we use it as long as the inheritance exists?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Because Dart doesn’t support multiple inheritance.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between print and debugPrint?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "In Android, if you will print a large output, for example, data returned from the API, and you print the response and the response is large, so part of it is printed for print.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "But the debugPrint has a parameter called wrap width.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This is where you specify the letters that are printed once, so if the letters that I specified are printed, and you are still faithful, a new line will be downloaded and continue to print it, by dividing you what you want to print on such and such print.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How are exceptions handled in Dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Exception handling in Dart is a crucial aspect of writing robust code. It involves using the try, catch, finally, and on keywords.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference Between Inheritance and Composition?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Inheritance represents an “is-a” relationship, where one class inherits the properties and behaviors of another class.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Composition represents a “has-a” relationship, where one class contains an instance of another class as a member.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference Between abstract and interface?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "An abstract class is a class that cannot be instantiated directly. Instead, it serves as a base or template for other classes to inherit from. Abstract classes provide a way to define a common interface for a set of related classes. They are similar to interfaces, but they can also contain method implementations.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "An interface is a contract that specifies a set of methods and properties that a class must implement. Unlike abstract classes, interfaces cannot contain method implementations — they only define the signature of the methods. A class can implement multiple interfaces, but it can only extend one class.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "extends is a keyword we use when we want a class to inherit another class’s methods and properties.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "implements is a keyword we use when we want to implement an interface.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference Between “extends\" and “implements\"?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Does Dart have higher-order functions?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Dart supports higher-order functions, which are a fundamental concept in functional programming.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Higher-order functions are functions that can take other functions as arguments and/or return a function. This feature allows for more flexible and reusable code.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "For example, you can pass a function as an argument to another function. This is often seen in methods like map, where, or forEach on collections.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                List<int> numbers = [1, 2, 3];
                                var squaredNumbers = numbers.map((number) => number * number);
                                print(squaredNumbers); // Output: (1, 4, 9)
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Dart Collection",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Dart doesn’t support the array to store the data, unlike the other programming language. We can use the Dart collection in place of array data structure. We can enable the other classes of the collection in our Dart script by using the dart::core library.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "List",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "A list is the collection of the ordered group of collection. The dart::core library offers the list class that allows us to create and modify the list. It provides the following types of lists.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Set",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "A set is the collection of the objects in which each object can be declared at once. The dart::core library offers the Set class to use its facilities.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Maps",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "The maps are the collection of the key-value pair of data. Each value is stored with a particular key. The key and value can be any type in the dart. A Map is a dynamic collection. We can say that map can be modified at the run-time. The dart::core library makes available the Map class to work with it.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Queue",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "A queue is the collection of the where data stores in the first-in-first-out format. It can be manipulated at both ends. Simply, we can enter the element from one end and delete it from another end.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Types of list in dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Fixed Length List ",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "We cannot change the list’s length at runtime.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                        Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Growable List",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Default growable list. We can change the length of the list at run-time.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }
                    }

                    KotlinCode(
                        code = """
                             1) Fixed: List<> myList = List<>(3);
                             2) growable list: List<> myList = List<>();
                             3) initialize List with values: List<> intList = [1, 2, 3];
                             4) by default, growable: false: var fixedList = List.filled(3, 1);
                             5) growable true: var growableList = List.filled(3, 2, growable: true);
                             6) list from: var growableList = List.from([1, 2, 3]);
                             7) unmodifiable: var unmodifiableList = List.unmodifiable([1, 2, 3]);
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Empty collection define.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        KotlinCode(
                            code = """
                                 Map: final param = <>{};
                                 List: List emptyList = List.empty();
                                       OR
                                 List<> vals = [];
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are Sealed classes?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Sealed classes in Dart, introduced in Dart 3.0, are used to create a known, enumerable set of subtypes, enhancing the language’s ability to handle type hierarchies and pattern matching.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The sealed modifier prevents a class from being extended or implemented outside its own library.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Sealed classes are implicitly abstract, meaning they cannot be instantiated themselves, but they can define constructors for their subclasses to use.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain abstract and sealed classes in Dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                SpanText(
                                    text = "Abstract class",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .fontWeight(FontWeight.Bold)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "It is a blue print for other classes. It cannot be instantiated o n its own but is meant to be subclass by other classes.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "It may contain abstract methods (methods without a body)that must b e implemented by its sub-classes.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                SpanText(
                                    text = "sealed class",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .fontWeight(FontWeight.Bold)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "A sealed class restricts its sub classes to a specific set d efined within the same file or library.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "It ensures that all the possible sub classes are known and handled, making code more robust and reducing unexpected behavior.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Sealed classes can not be instantiated same as abstract classes.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "In sealed class, we can have methods with their bodies unlike abstract classes.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How to create a Generic sealed Response?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        KotlinCode(
                            code = $$"""
                                //E: Error S: Success
                                sealed class BaseResponse<E, S> {
                                  const BaseResponse();
                                }

                                final class Success<E, S> extends BaseResponse<E, S> {
                                  const Success(this.value);
                                  final S value;
                                }

                                final class Failure<E, S> extends BaseResponse<E, S> {
                                  const Failure(this.exception);
                                  final E exception;
                                }

                                /*
                                  final value = switch (response) {
                                      Success(value: final loginEntity) => print(loginEntity.toString()),
                                      Failure(exception: final exception) => 'Something went wrong: $exception',
                                    };
                                */
                                sealed class Response<T> {}

                                final class Success<T> extends Response<T> {
                                  final T data;
                                  Success({required this.data});
                                }

                                final class Failure<T> extends Response<T> {
                                  final T exception;
                                  Failure({required this.exception});
                                }
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Remove point (float) value or rounding value in Dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        KotlinCode(
                            code = """
                                 var num = 10.12345678;
                                 var removePointValue = double.parse(num.toStringAsFixed(2));

                                 //Get Round Value
                                 var roundingValue= double.parse(num.toStringAsFixed(0));
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are Records?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Records are an anonymous, immutable, aggregate type. Like other collection types, they let you bundle multiple objects into a single object. Unlike other collection types, records are fixed-sized, heterogeneous, and typed.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Records are real values; you can store them in variables, nest them, pass them to and from functions, and store them in data structures such as lists, maps, and sets.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "In a record type annotation, named fields go inside a curly brace-delimited section of type-and-name pairs, after all positional fields. In a record expression, the names go before each field value with a colon after:",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                 var record = ('first', a: 2, b: true, 'last');
                            """.trimIndent()
                        )

                        KotlinCode(
                            code = """
                                // Record type annotation in a variable declaration:
                                ({int a, bool b}) record;
                                
                                // Initialize it with a record expression:
                                record = (a: 123, b: true);
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How Parallel Programming is implemented in Dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Isolates in Dart are a powerful feature for achieving concurrency. Unlike threads in other languages, each Dart isolate has its own memory heap, ensuring that no isolate’s state can be accessed from any other isolate.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Each isolate runs independently, with its own event loop and memory. This isolation ensures that one isolate’s operations don’t block the execution of another.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Isolates communicate exclusively via message passing. Data sent between isolates is copied, not shared, which preserves the isolation between them.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "They are ideal for performing CPU-intensive tasks like heavy computations or processing large amounts of data. They allow these tasks to be handled in a way that doesn’t block the main isolate, which is typically handling UI interactions.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You can spawn a new isolate using Isolate.spawn(). The new isolate executes code independently and can communicate with the spawning isolate through ports.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between Isolate, Thread and Process?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Isolate: In Dart, an isolate is a single-threaded worker that runs independently. It doesn’t share memory with other isolates, which makes it great for parallel processing without the risk of race conditions.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Thread: Threads run within the same process and share memory. They are lighter than processes but can introduce complexity with shared data, leading to potential issues like deadlocks.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Dart 2.17 Super",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        KotlinCode(
                            code = """
                                class Person {
                                  Person (this.name); final String name;
                                }

                                class Employee extends Person {
                                  Employee(super.name, this.salary);
                                  final int salary;
                                }
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are “async”, “await ”and “Future”?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Async means that this function is asynchronous, and you might need to wait a bit to get its result.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Await literally means wait here until this function is finished and you will get its return value.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Future is a type that “comes from the future” and returns a value from your asynchronous function. It can complete with success(.then) or with an error(.catchError)",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between Future and Stream?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between async vs async* in flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                SpanText(
                                    text = "async",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .fontWeight(FontWeight.Bold)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "async is your trusty tool for handling a single asynchronous operation.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "It employs await and async to deal with asynchronous tasks sequentially.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Functions marked as async return a Future and use return to deliver the result once the operation is complete.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                SpanText(
                                    text = "async*",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .fontWeight(FontWeight.Bold)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "async* allows you to emit values gradually over time, introducing a dynamic aspect to your code.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "The countdown values (5, 4, 3, 2, 1) are not generated all at once.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "It elegantly returns a ‘Stream’, allowing for the gradual production of values using the yield keyword.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Unlike async, async* is used in functions that emit a stream of values over time rather than returning a single result.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "async* keyword is used to mark a function as an asynchronous generator, meaning that it returns an object that implements the Stream interface and can be used to yield a sequence of values asynchronously.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is Cascade notation in dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Cascades (.., ?..) allow you to make a sequence of operations on the same object. In addition to accessing instance members, you can also call instance methods on that same object.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                var paint = Paint()
                                ..color = Colors.black
                                ..strokeCap = StrokeCap.round
                                ..strokeWidth = 5.0;
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is concurrency in Dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Concurrency is the execution of several instruction sequences at the same time. It involves performing more than one task simultaneously. Dart uses Isolates as a tool for doing work in parallel.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are dart callable classes?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Dart provides the facility to call class instances like a function. To make callable class, we need to implement a call() method in it.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = """
                             class Addition {
                               int call(int a, int b) => a + b;
                             }

                             void main() {
                               Addition addition = Addition();
                               var result = addition(1, 5);
                               print(result); // 6
                             }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is Runes in Dart.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A rune can be defined as an integer used to represent any Unicode code point. As a Dart string is a simple sequence of UTF-16 code units, 32-bit Unicode values in a string are represented using a special syntax. The String class in the dart:core library gives ways to access runes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is HTML DOM in Dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Every webpage can be considered an object and it exists inside a browser window. We can access the webpage using the web browser and it needed to be connected to the internet. The DOM is the acronym for the Document object model. A Document object denotes the HTML document that is displayed in that window.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain Covariant in Dart?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The `covariant` keyword in Dart serves an important purpose when it comes to method overriding in class inheritance. Specifically, it allows a subclass to redefine a method from its parent class so that the method can accept parameters of a different, more specific type than those defined in the original parent class method.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This capability is instrumental in scenarios involving polymorphism, where you can enhance the functionality of inherited methods while still adhering to a consistent interface. By effectively leveraging covariance, developers can create methods that are not only flexible but also more tailored to the specific needs of their applications.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "For instance, when customizing a widget, a developer might want to override a method from a parent widget to return a more specific type of widget, ensuring better compatibility and type safety.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = """
                        @override
                        void didUpdateWidget(covariant SliderWidget oldWidget) {
                            super.didUpdateWidget(oldWidget);
                            _initialiseVariable();
                        }
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is RepaintBoundary?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "RepaintBoundary is a widget that acts as a buffer in Flutter's rendering pipeline. It isolates its child and any subtree from unnecessary repaints whenever its parent widget updates.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Instead of causing the whole widget tree to repaint, it ensures that only the widget subtree inside the boundary is repainted when necessary. This helps reduce the computational load and ensures smoother animations and UI interactions.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "RepaintBoundary work",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Imagine a parent widget that updates frequently, like a scrolling list or an animation. Without RepaintBoundary, every time the parent updates, the entire subtree of the child widget repaints, even if the change didn’t affect the child directly. With RepaintBoundary, Flutter redraws only the parts that changed, boosting performance and ensuring that non-affected areas remain intact.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    KotlinCode(
                        code = """
                            ListView.builder(
                              itemBuilder: (context, index) {
                                return RepaintBoundary(
                                  child: ListItemWidget(),
                                );
                              },
                            )
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                            RepaintBoundary(
                              child: Slider(
                                value: currentValue,
                                onChanged: (newValue) {
                                  setState(() {
                                    currentValue = newValue;
                                  });
                                },
                              ),
                            )
                        """.trimIndent()
                    )

                    KotlinCode(
                        code = """
                             debugRepaintRainbowEnabled = true;
                        """.trimIndent()
                    )
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is LookupBoundary?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A LookupBoundary controls what entities are visible to descendants of the boundary via the static lookup methods provided by the boundary. The static lookup methods of the boundary mirror the lookup methods by the same name exposed on BuildContext, and they can be used as direct replacements. Unlike the methods on BuildContext, these methods do not find any ancestor entities of the closest LookupBoundary surrounding the provided BuildContext. The root of the tree is an implicit lookup boundary.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "When to Use LookupBoundary?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "There is a need to control the scope of visibility for various entities in your widget tree.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You want to create clear boundaries for widget lookups in complex widget trees.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You need to optimize performance by limiting the lookup scope.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                SpanText(
                    text = "Dart 3",
                    modifier = Modifier.fontSize(FontSize.Large)
                        .fontWeight(FontWeight.Bold)
                )

                KotlinCode(
                    code = $$"""
                    typedef Student = ({String name, int number});

                    extension StudentExtension on Student {
                       void sayHi() {
                         debugPrint('Hi, I am ${this.name}. No.$number');
                       }
                    }

                    void main() {
                       const Student student = (name: 'Yii', number: 1);
                       student.sayHi();
                    }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                    class Student {
                       Student({
                         required this.name,
                         required this.number,
                       });

                       final String name;
                       final int number;

                       (String, int) _equality() => (name, number);

                       @override
                       bool operator ==(covariant Student other) {
                         if (identical(this, other)) return true;
                        
                         return other._equality() == _equality();
                       }

                       @override
                       int get hashCode => _equality().hashCode;
                    }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                    final hasAndy = switch (json) {
                     {'data': List items} => items.any((element) => switch (element) {
                          {'name': 'Andy'} => true,
                             _ => false,
                           }),
                       _ => false,
                    };

                    print(hasAndy); // true
                    """.trimIndent()
                )

                KotlinCode(
                    code = $$"""
                    final rgb = [255, 255, 255];

                    if (rgb case [int red, int green, int blue]) {
                       debugPrint('$red, $green, $blue');
                    }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                    int getPrice(bool canKnowPrice) {
                      int price;

                      if (canKnowPrice) {
                        price = 20;
                      } else {
                        // 1.
                        price = -1;
                        // 2.
                        throw Exception('Something wrong.');
                      }

                      return price;
                    }
                    """.trimIndent()
                )

                SpanText(
                    text = "Dart 3.3.0",
                    modifier = Modifier.fontSize(FontSize.Large)
                        .fontWeight(FontWeight.Bold)
                )

                KotlinCode(
                    code = $$"""
                    extension type NumberExtension(int i) {
                      // Custom methods and properties specific to integers
                      bool isEven() => i % 2 == 0;
                      String doubleIt() => 'Double: ${i * 2}';
                    }

                    void main() {
                      final number = NumberExtension(13); // Use extension type notation

                        print('Double it : ${number.doubleIt()}');
                        print('Is Even: ${number.isEven()}');
                    }
                    """.trimIndent()
                )

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you reduce widget rebuild?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You rebuild widgets when the state changes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This is normal and desirable because it allows the user to see the state changes reflected in the UI. However, rebuilding parts of the UI that don’t need to change is wasteful. There are several things you can do to reduce unnecessary widget rebuilding.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The first is to refactor a large widget tree into smaller individual widgets, each with its build method.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Whenever possible, use the const constructor, because this will tell Flutter that it doesn’t need to rebuild the widget.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Keep the subtree of a stateful widget as small as possible. If a stateful widget needs to have a widget subtree under it, create a custom widget for the stateful widget and give it a child parameter.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are DevTools in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "DevTools in Flutter are a set of tools used for performance management and debugging.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "With these tools, you can inspect the UI layout, diagnose the UI performance issues, perform source-level debugging, view general log & diagnostics information, and more.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This tool is still in preview release but you can test the alpha version of this tool by clicking the “beaker” icon in the upper-right corner of DevTools.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are packages and plugins in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A package is a group of similar types of classes, interfaces, and sub-packages. The packages and plugins help us to build the app without having to develop everything from packages.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "runZoned",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This function allows you to run code within a new zone. It can catch and handle errors if you provide an onError callback, but it won't prevent the app from crashing. It's useful for handling non-critical exceptions and logging errors for diagnostics.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "runZonedGuarded",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This function offers a \"guarded\" approach by creating an error zone where any uncaught exceptions are captured and handled without causing the app to crash. It's recommended for production apps because it ensures the app remains stable even when unexpected errors occur.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you find and fix a 60 → 30fps drop?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Profile with Flutter DevTools: check CPU vs GPU. If UI thread is busy, look for expensive rebuilds (widgets that call heavy work in build), expensive layout, or synchronous work. Use RepaintBoundary, const, memoization, and move heavy tasks to an isolate.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle app startup performance?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Defer heavy work off the first frame — show a light splash, lazy-load feature modules, and prefetch only essential resources. Use WidgetsBinding.instance.addPostFrameCallback for non-urgent initialization.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you approach memory leaks?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "ook for retained listeners (streams, controllers) not closed, heavy caches never cleared, and large image objects. Use DevTools to inspect memory, lifecycle logs, and ensure dispose() cleanups.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How does Flutter’s rendering pipeline work?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Widgets → Describe the UI.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Element Tree → Tracks widget state and builds RenderObjects.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Render Tree → Handles layout, painting, and composition. Draws to canvas.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Compositing → Uses Skia to render on the screen. Layer tree → Scene → GPU",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        KotlinCode(
                            code = """
                                class CustomBox extends RenderBox {
                                  @override
                                  void paint(PaintingContext context, Offset offset) {
                                    final paint = Paint()..color = Colors.blue;
                                    context.canvas.drawRect(offset & size, paint);
                                  }
                                }
                            """.trimIndent()
                        )
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between main() and runApp() functions in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The main() function is responsible for starting the program. Without the main() function, we cannot write any program on Flutter.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The runApp() function is responsible for returning the widgets that are attached to the screen as a root of the widget tree and will be rendered on the screen.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Can main() be overloaded?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "No, Dart does not support function overloading. There must be exactly one main() entry point per isolate.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Can you tell which function is accountable for starting the program?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "main() function is used to start a program. This function is highly critical as, without it, one cannot write any function.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Do you know the difference between dependencies and dev_dependencies in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                SpanText(
                                    text = "Dependencies",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .fontWeight(FontWeight.Bold)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Packages your project needs to run.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "These are included in the app production build.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Examples: dio, flutter_riverpod and flutter_local_notifications.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                SpanText(
                                    text = "DevDependecies",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .fontWeight(FontWeight.Bold)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Packages you as a developer need during development.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "These packages are not needed in the final app build.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "Examples: flutter_test, flutter_lints and build_runner.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are packages and plugins in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A package is a group of similar types of classes, interfaces, and sub-packages. The packages and plugins help us to build the app without having to develop everything from packages.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why is the Android and iOS folder in the Flutter project?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                SpanText(
                                    text = "Android",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .fontWeight(FontWeight.Bold)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "This folder holds a complete Android project. It is used when you create the Flutter application for Android.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "When the Flutter code is compiled into the native code, it will get injected into this Android project, so that the result is a native Android application.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "For Example: When you are using the Android emulator, this Android project is used to build the Android app, which is further deployed to the Android Virtual Device.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                SpanText(
                                    text = "iOS",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .fontWeight(FontWeight.Bold)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "This folder holds a complete Mac project.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "It is used when you build the Flutter application for iOS.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "It is similar to the Android folder, which is used when developing an app for Android.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }

                                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "When the Flutter code is compiled into the native code, it will get injected into this iOS project, so that the result is a native iOS application.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the tree shaking in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Tree shaking is an optimization technique to remove the unused module in the bundle during the build process. It is a dead code elimination technique used to optimize the code. A build-time optimization that removes code that is never used: unused classes, functions and parts of packages. Flutter also shakes icon fonts, so only the icons you use are bundled. The result is a smaller app.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }

                    //flutter build apk --analyze-size
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the purpose of the pubspec.yaml file in a Flutter project?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The pubspec.yaml file in a Flutter project serves as a central configuration file, encapsulating crucial information and dependencies for the project. It holds metadata about the project and outlines the dependencies required for the Flutter app.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Key Purposes of pubspec.yaml:",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Dependency Management",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Lists all the dependencies, including the Flutter SDK itself and any external packages or plugins needed for the project.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Specifies the version constraints for each dependency to ensure compatibility.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Project Metadata",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Contains essential project details such as the name, description, version, and author information.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Defines the project’s homepage and repository details.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Asset Configuration",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Includes configurations for project assets, such as images, fonts, and other resources.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Specifies the location of assets and how they should be handled in the build process.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Environment Configuration",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Defines the minimum Flutter SDK version required for the project.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Specifies any SDK-specific configurations or constraints.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "By consolidating these details in the pubspec.yaml file, Flutter developers can efficiently manage project dependencies, configure assets, and ensure consistency across development environments. This file plays a crucial role in facilitating smooth collaboration, reproducibility, and efficient project maintenance.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "FlutterActivity",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Activity which displays a full screen Flutter UI.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "FlutterActivity is the simplest and most direct way to integrate Flutter within an Android app.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The Dart entry point executed within this Activity is “main()” by default.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The entrypoint may be specified explicitly by passing the name of the entrypoint method as a String in EXTRA_DART_ENTRYPOINT, e.g., “myEntrypoint”.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The Flutter route that is initially loaded within this Activity is “/”.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "FlutterActivity responsibilities?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Displays an Android launch screen. Displays a Flutter splash screen.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Configures the status bar appearance.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Chooses the Dart execution app bundle path and entry point.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Chooses Flutter’s initial route. Renders Activity transparently, if desired.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Offers hooks for subclasses to provide and configure a FlutterEngine.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a Flutter inspector?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Flutter inspector is a tool that helps in visualizing and exploring the widget trees. It helps in understanding the present layout and diagnoses various layout issues. The following are the various advantages of Flutter Inspector: Select widget mode, Toggle platform, show paint baselines, Show debug paint, Refresh widget, Enable slow animations, Show/hide performance overlay.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the purpose of the pubspec.yaml file in a Flutter project?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The pubspec.yaml file in a Flutter project serves as a central configuration file, encapsulating crucial information and dependencies for the project. It holds metadata about the project and outlines the dependencies required for the Flutter app.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Key Purposes of pubspec.yaml:",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Dependency Management",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Lists all the dependencies, including the Flutter SDK itself and any external packages or plugins needed for the project.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Specifies the version constraints for each dependency to ensure compatibility.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Project Metadata",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Contains essential project details such as the name, description, version, and author information.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Defines the project’s homepage and repository details.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Asset Configuration",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Includes configurations for project assets, such as images, fonts, and other resources.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Specifies the location of assets and how they should be handled in the build process.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Environment Configuration",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Defines the minimum Flutter SDK version required for the project.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Specifies any SDK-specific configurations or constraints.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "By consolidating these details in the pubspec.yaml file, Flutter developers can efficiently manage project dependencies, configure assets, and ensure consistency across development environments. This file plays a crucial role in facilitating smooth collaboration, reproducibility, and efficient project maintenance.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What types of tests can you perform in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                SpanText(
                                    text = "Unit Tests",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .fontWeight(FontWeight.Bold)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "It tests a single function, method, or class. Its goal is to ensure the correctness of code under a variety of conditions. This testing is used for checking the validity of our business logic.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                SpanText(
                                    text = "Widget Tests",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .fontWeight(FontWeight.Bold)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "It tests a single widget. Its goal is to ensure that the widget's UI looks and interacts with other widgets as expected.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }

                        Ul {
                            Li(Modifier.padding(top = 1.em).toAttrs()) {
                                SpanText(
                                    text = "Integration Tests",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                        .fontWeight(FontWeight.Bold)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                    SpanText(
                                        text = "It validates a complete app or a large part of the app. Its goal is to ensure that all the widgets and services work together as expected.",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                    )
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain the different types of build modes?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Flutter provides different build modes to cater to various development and deployment scenarios, each optimized for specific purposes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Here are the different build modes in Flutter:",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Debug Mode",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "This mode is primarily used during development. It enables features like hot reload for quick iteration and extensive logging for debugging purposes.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Limited optimizations are applied, focusing on a faster development cycle.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "This mode enables debugging of apps on a physical device, emulator, or simulator.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Profile Mode",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Profile mode is used when you want to analyze performance.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Profile mode is an intermediate step between debug and release modes. It includes some optimizations to simulate the performance of a release build while retaining debugging support.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Moderate optimizations are applied, providing a balance between development speed and runtime performance.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "The command flutter run — profile compiles to profile mode.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Profile mode is disabled on the emulator and simulator, because their behavior is not representative of real performance.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Some service extensions, such as the one that enables the performance overlay, are enabled. Tracing is enabled, and tools supporting source-level debugging (such as DevTools) can connect to the process. Profile mode for a web app means that: The build is not minified but tree shaking has been performed. The app is compiled with the dart2js compiler.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Release Mode",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Release mode is intended for production-ready builds. It enables maximum optimizations, resulting in smaller binary sizes and improved runtime performance.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Extensive optimizations, including tree shaking and dead code elimination, are applied for efficient and streamlined execution.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Why does it generally take a long time to develop a Flutter app?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Because Flutter generates a device-specific IPA or APK file, building a Flutter application takes substantially longer the first time. This method, which normally takes a long time, uses Xcode and Gradle to build a file.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Can you tell us the four main elements of Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Flutter engine, Widgets, Design-specific widgets, and Foundation Library",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a RenderBox in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A RenderBox in Flutter is a type of RenderObject that lays out and paints its children within a given space, usually in a 2D Cartesian coordinate system. It's a fundamental building block in Flutter's rendering pipeline, responsible for performing layout, hit-testing, painting, and responding to gestures in the UI. Essentially, it forms the backbone of the visual rendering process, converting abstract widget trees into pixel-perfect displays.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain the concept of context in Flutter.",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Context in Flutter is a handle to the location of a widget in the widget tree. It's vital because it allows you to access theme data, other widgets, and perform actions like navigating or showing dialogs. For instance, if you want to access a specific widget higher up in the tree or use an inherited widget's data, you use the context to do that. Keep in mind, context is specific to the widget it’s called from, and can’t be used outside its lifecycle or after the widget is disposed.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are keys in Flutter, and when to use it?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Keys in Flutter are used as an identifier for Widgets, Elements, and SemanticsNodes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "We can use it when a new widget tries to update an existing element; then, its key should be the same as the current widget key associated with the element.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Keys should not be different amongst the Elements within the same parent.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The subclasses of Key must be a GlobalKey or LocalKey.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Keys are useful when we try to manipulate (such as adding, removing, or reordering) a collection of widgets of the same type that hold some state.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Difference between MediaQuery and LayoutBuilder?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "MediaQuery provides a higher-level view of the current app’s screen size and can also give more detailed information about the device and its layout preferences.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "LayoutBuilder helps to create a widget tree in the widget flutter which can depend on the size of the original widget.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the use of AspectRatio?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You can use the widget to size the child to a specific aspect ratio. This widget first tries the largest width permitted by the layout constraints and then decides the height by applying the given aspect ratio to the width.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What do you understand from State? What is the use of the setState() method?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The state is the data that your application currently showing.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "State refers to the information that you can read synchronously when a widget is built and it might change during the lifetime of the widget.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The setState() method is used to notify the changed state of an internal object.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is state management?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Using it, states of various UI controls are centralized to handle data flow across an application. It can be a text field, radio button, checkbox, dropdown, toggle, form, and so on.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "Ephemeral State",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "Ephemeral state is also called UI state or local state, and it pertains to a particular widget. In other words, it is a state that is contained within the specific widget. By means of StatefulWidget, Flutter provides support for this state.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "App State",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "This is different from the ephemeral state since it is a state that we intend to share across different parts of the app and which we want to maintain between sessions. These types of states can thus be used globally. By means of scoped_model, Flutter provides support for this state.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the State?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A widget’s “state” is the information or data that it holds over time. It determines how the widget should be displayed on the screen.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "When a widget’s state changes, it is rebuilt to reflect the updated state. The result is a dynamic, responsive user interface. In simple words, State is the data that changes and updates the widgets on the app’s UI.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is BuildContext and how is it useful?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The state is the data that your application currently showing.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "BuildContext is the widget’s element in the Element tree — so every widget has its own BuildContext.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You usually use BuildContext to get a reference to the theme or another widget. For example, if you want to show a material dialog, you need a reference to the scaffold. You can get it with Scaffold.of(context), where context is the build context. of() searches up the tree until it finds the nearest scaffold.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are the keys in Flutter and when to use it?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A Key is a unique identifier for a widget that allows Flutter to identify a widget from its previous state. Keys are used to identify widgets when the widget tree changes, so that Flutter can preserve state for those widgets.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You should use keys in Flutter whenever you need to identify a widget and preserve its state. This is typically necessary when you are working with lists of widgets, or when you are building widgets that need to be able to update their state based on user interactions.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "For example, if you have a list of items that can be reordered by the user, you can use keys to identify each item and preserve its state when it is reordered. Similarly, if you have a form with multiple input fields, you can use keys to identify each field and preserve its state as the user fills out the form.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It’s important to note that keys should only be used when necessary, as they can have a performance impact on your app. You should only use keys when you need to identify a widget and preserve its state, and you should choose the appropriate type of key based on your needs.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "There are several types of keys in Flutter, including:",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "GlobalKey",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "A global key is unique across the entire app, and is useful when you need to identify a widget from a different part of the app.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "It allows developers to access the data of one widget inside another in your application. It can help the developers but can also destroy the state management.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "UniqueKey",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "A unique key is unique within a widget’s parent widget, and is useful when you need to identify a widget within a list of widgets.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }

                                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "It stores every widget state as unique. It is easy to identify them when we need to recall them.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "ValueKey",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "A value key is based on a value, such as a string or an integer, and is useful when you need to identify a widget within a list of widgets based on its value.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }

                            Ul {
                                Li(Modifier.padding(top = 1.em).toAttrs()) {
                                    SpanText(
                                        text = "ObjectKey",
                                        modifier = Modifier
                                            .fontSize(FontSize.Medium)
                                            .fontWeight(FontWeight.Bold)
                                    )
                                }

                                Ul {
                                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                        SpanText(
                                            text = "It stores complex objects in which multiple objects have the same values, such as date of birth or name. It usually would be a custom class.",
                                            modifier = Modifier
                                                .fontSize(FontSize.Medium)
                                        )
                                    }
                                }
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Can you nest a Scaffold? Why or why not?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Yes, you can nest a Scaffold.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "That’s the beauty of Flutter. You control the entire UI. Scaffold is just a widget, so you can put it anywhere a widget might go. By nesting a, you can layer drawers, snack bars, and bottom sheets.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Can you nest a Scaffold? Why or why not?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Yes, you can nest a Scaffold. That’s the beauty of Flutter. You control the entire UI.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Scaffold is just a widget, so you can put it anywhere a widget might go. By nesting a, you can layer drawers, snack bars, and bottom sheets.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Yes, you can nest a Scaffold. That’s the beauty of Flutter. You control the entire UI.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Scaffold is just a widget, so you can put it anywhere a widget might go. By nesting a, you can layer drawers, snack bars, and bottom sheets.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is The Flex widget in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The Flex widget allows you to control the axis along which the children are placed (horizontal or vertical).",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "This is referred to as the main axis. If you know the main axis in advance, then consider using a Row (if it's horizontal) or Column (if it's vertical) instead, because that will be less verbose.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are the differences between expanded and flexible widgets?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Flexible is use to resize the widgets in rows and columns. It's mainly used to adjust the space of the different child widgets while keeping the relation with their parent widgets.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Mean while, Expanded changes the constraints sent to the children of rows and columns; it helps to fill the available spaces there. Therefore, when you wrap your child in an Expanded widget it fills up the empty spaces.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "When should you use mainAxisAlignment and crossAxisAlignment?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "We can use the crossAxisAlignment and mainAxisAlignment to control how row and column widgets align their children based on our choice.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The row's cross-axis will run vertically, and the main axis will run horizontally. See the below visual representation to understand it more clearly.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The column's cross-axis will run horizontally, and the main axis will run vertically. The below visual representation explains it more clearly.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(

                                    text = "ROW - Horizontal - mainAxisAlignment (RHM)",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "COLUMN - Horizontal - crossAxisAlignment (CHC)",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the Container widget in flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The Container widget provides the ability to create a widget with certain properties like padding, borders, height, width, border, etc.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Can a container have more than one child?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A container is a Single-child layout widget. But it can have multiple children by using a Multi-child layout widget as its child.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Explain FittedBox Widget?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "FittedBox is a widget used to scale and position its child within the parent's box according to specified fit type and alignment.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is InheritedWidget?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "InheritedWidget efficiently propagates data down the widget tree without explicitly passing it through every widget.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                //BLOC STATE MANAGEMENT PATTERN
                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are the two main components of BLoC?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The two main components of BLoC are the Sink and the Stream. The Sink is used to input events into the BLoC, while the Stream emits the output state.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you implement BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "BLoC can be implemented in Flutter using streams and StreamControllers. You create a BLoC class that extends the StreamController and defines methods for handling events and updating the app’s state. In the UI layer, you use StreamBuilder widgets to listen to changes in the BLoC’s stream and update the UI accordingly.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the purpose of the initialState parameter in a BLoC constructor?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The initialState parameter in a BLoC constructor is used to specify the initial state of the BLoC when it is first created. It defines the state that the BLoC will emit before any events are processed.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle user input with BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "User input with BLoC in Flutter is typically handled by creating Sink methods in the BLoC class to receive events triggered by user interactions, such as button presses or text input changes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between BlocBuilder and BlocListener widgets in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "BlocBuilder is used to rebuild its UI based on the latest state emitted by the BLoC, while BlocListener is used to perform side effects in response to state changes, such as showing a Snackbar or navigating to a new screen.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the purpose of the emit() method in a BLoC class?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The emit() method in a BLoC class is used to emit a new state to the stream of states, notifying listeners that the state of the BLoC has changed.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you dispose of a BLoC in Flutter to prevent memory leaks?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "To dispose of a BLoC in Flutter and prevent memory leaks, you typically override the dispose() method in the BLoC class and close any streams or controllers that the BLoC uses.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the purpose of the StreamController in BLoC?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The StreamController is used to create and manage streams of data in BLoC. It allows the BLoC to add data to the stream (through the Sink) and notify listeners when new data is available.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle asynchronous operations with BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Asynchronous operations in BLoC can be handled by using asynchronous methods within the BLoC class or by working with asynchronous streams to represent data that arrives over time.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you listen for state changes in a BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You can listen for state changes in a BLoC using widgets like StreamBuilder or BlocBuilder, which rebuild their UI in response to new state emissions from the BLoC.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle errors in BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Errors in BLoC can be handled by emitting error states to the stream of states using methods like emitError(). Widgets can then listen for error states and display error messages or perform error recovery logic.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is a BehaviorSubject in BLoC?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "A BehaviorSubject is a type of StreamController in BLoC that allows listeners to access the most recent item that has been added to the stream, as well as subsequent items as they are added.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle navigation with BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Navigation with BLoC in Flutter can be handled by emitting navigation events from the BLoC in response to user actions or business logic triggers. Widgets can listen for these navigation events and respond by navigating to the appropriate screen using methods like Navigator.push().",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the purpose of the sink in BLoC?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The sink in BLoC is used to add input data or events into the BLoC. It is an endpoint for sending data into the BLoC’s internal logic.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle state changes in a BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "State changes in a BLoC are typically managed by emitting new states through the BLoC’s stream. Widgets that listen to the BLoC’s stream rebuild their UI in response to these state changes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the difference between a BLoC and a StatefulWidget in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "While both BLoC and StatefulWidget are used for managing state in Flutter, BLoC separates business logic from UI, promoting a more modular and testable architecture. StatefulWidget, on the other hand, is a built-in Flutter widget used for managing mutable state directly within the UI.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle side effects in a BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Side effects in a BLoC, such as making network requests or accessing local storage, are typically handled using libraries like bloc and flutter_bloc, which provide mechanisms like BlocListener to perform side effects in response to state changes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the purpose of the stream in BLoC?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The stream in BLoC is used to emit output data or states from the BLoC to its listeners. It allows the BLoC to notify the UI layer of changes in state.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle dependency injection with BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Dependency injection with BLoC in Flutter is typically handled by providing the BLoC instance to the widget tree using a BLoCProvider widget. This allows descendant widgets to access the BLoC instance through the context.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "Can you have multiple BLoCs in a Flutter application?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Yes, you can have multiple BLoCs in a Flutter application. Each BLoC typically manages a specific part of the application’s state and business logic.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the role of StreamController in BLoC?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "StreamController is used in BLoC to manage the flow of data and events between the UI layer and the BLoC layer.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It allows you to create and manage streams of data, handle events, and listen for changes in the data stream.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "StreamController provides methods for adding data to the stream and closing the stream when it’s no longer needed.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the role of RxDart in BLoC architecture?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "RxDart plays a crucial role in BLoC architecture by providing powerful tools and abstractions for handling asynchronous data streams and events.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "It extends Dart’s built-in streams with additional functionality, such as stream transformation operators, BehaviorSubjects, and stream controllers.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "RxDart allows developers to compose and manipulate streams using functional reactive programming (FRP) principles, making it easier to manage complex data flows and handle asynchronous operations efficiently in BLoC-based applications.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle asynchronous operations with BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Asynchronous operations with BLoC in Flutter are typically handled using streams and asynchronous methods.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "BLoC classes can expose streams of data representing asynchronous operations, such as network requests or database queries, and emit events to notify the UI layer of the operation’s progress or result.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Additionally, BLoC classes can use async/await syntax within their methods to perform asynchronous computations and return Future objects representing the result.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "By leveraging streams and Futures, BLoC-based applications can handle asynchronous operations efficiently and provide responsive user experiences.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the role of Equatable in BLoC architecture?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Equatable is a package in Dart that provides utilities for comparing objects for equality. It is commonly used in BLoC architecture to compare states and determine whether the state has changed. By extending the Equatable class and overriding the == and props methods, BLoC states can implement value-based equality comparison, making it easier to detect state changes and trigger UI updates efficiently.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle global app state with BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Global app state can be managed with BLoC in Flutter by using a singleton pattern to create a global instance of the BLoC class and providing it to the entire widget tree using an InheritedWidget or Provider. This allows all widgets in the app to access and interact with the global state using BLoC, ensuring consistency and centralized management of the app’s state.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are some common patterns for structuring BLoC classes in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Single responsibility principle (SRP): Ensuring that each BLoC class has a single responsibility or concern, such as managing a specific piece of state or handling a particular aspect of the app’s behavior.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Separation of concerns: Separating business logic from UI components by keeping BLoC classes decoupled from the UI layer and relying on streams to communicate state changes between the BLoC and UI.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Composition over inheritance: Using composition to combine multiple BLoC instances or delegates to handle complex state dependencies and interactions, rather than relying on inheritance or monolithic BLoC implementations.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle form validation with BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Form validation with BLoC in Flutter can be handled by using streams to represent the validation status of form fields and emitting validation events from the BLoC in response to user input.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "The UI layer listens for these validation events and updates the form’s visual state accordingly, such as displaying error messages or changing the appearance of invalid fields.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "BLoC classes can encapsulate the validation logic and expose streams of validation events to the UI layer, allowing for dynamic and reactive form validation.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What is the role of BLoC delegates in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "BLoC delegates in Flutter are reusable components or mixins that encapsulate common BLoC functionality and can be composed together to create complex BLoC implementations.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "BLoC delegates provide a way to modularize and reuse BLoC logic across multiple classes, making it easier to manage and maintain BLoC code.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Examples of BLoC delegates include state management mixins, event handlers, and stream transformers.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle state persistence and restoration with BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "State persistence and restoration with BLoC in Flutter can be achieved by serializing BLoC states to a persistent storage mechanism, such as SharedPreferences or SQLite, and restoring the state from storage when the app is restarted.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "BLoC classes can implement methods to serialize and deserialize state objects to and from JSON or other data formats, allowing the app to maintain state across app sessions or device restarts.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are some strategies for handling complex asynchronous workflows with BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Strategies for handling complex asynchronous workflows with BLoC in Flutter include using stream transformers and combining streams to orchestrate multiple asynchronous operations.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "You can use operators like switchMap, mergeMap, or concatMap to combine streams of events and perform sequential or parallel processing of asynchronous tasks.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Additionally, using error handling operators like catchError can help manage errors and failures gracefully within the BLoC layer.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you handle real-time updates and synchronization with BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Real-time updates and synchronization with BLoC in Flutter can be achieved using streams and WebSocket connections to listen for changes in data and push updates to the UI layer in real time.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "BLoC classes can subscribe to WebSocket channels or stream-based APIs to receive real-time updates and emit events to notify the UI layer of changes.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Additionally, BLoC classes can use stream transformers like debounce or throttle to control the frequency of updates and prevent UI flickering or excessive redraws.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "How do you test a BLoC in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "BLoCs can be tested using unit tests and integration tests. Unit tests can be used to test individual methods and business logic within the BLoC, while integration tests can be used to test the interaction between the BLoC and its dependencies.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "What are some best practices for testing BLoC classes in Flutter?",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Writing unit tests to verify the behavior of individual BLoC methods and functions, such as event handlers, state transformations, and stream subscriptions.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Mocking dependencies and external services using mock objects or stubs to isolate the BLoC being tested and ensure that tests are focused and deterministic.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Using test doubles, such as fake streams or BehaviorSubjects, to simulate asynchronous data streams and events and validate the BLoC’s behavior under different conditions.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }

                            Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "Testing edge cases and error scenarios to ensure that the BLoC behaves correctly and handles unexpected conditions gracefully, such as network errors, invalid input, or empty data sets.",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }

                KotlinCode(
                    code = $$"""
                        void main() {
                          List<int> numbers1 = [1, 2, 3, 4, 5];
                          List<int> numbers2 = numbers1;
                          //numbers2 now references the same list object as numbers1
                          // (no new list object is created for "numbers2").
                          numbers1.clear(); //Check this line comment
                          //This modifies the existing list;
                          // Both numbers and numbers2 are affected.
                          print('After clear(): $numbers1, $numbers2');
                          // Output: After clear: [], []
                          numbers1 = [];
                          //This creates a new list and assigns it to numbersi, but
                          //numbers2 still references the original list.
                          print('After reset with []: $numbers1, $numbers2');
                          //Output: After reset with []: [], [1, 2, 3, 4, 5]
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        //Create a Flutter function that takes an integer parameter 'n' 
                        //and returns the sum of all numbers from 1 to 'n'. 
                        //What is the correct code snippet?

                        main(){
                          print(calculateSum(5));
                        }

                        double calculateSum(int n) => n * (n + 1) / 2;
                    """.trimIndent()
                )

                KotlinCode(
                    code = $$"""
                        //First element not sorting ascending order

                        fun main() {
                            val originalMap = hashMapOf(
                                "Key1" to 35,
                                "Key2" to 28,
                                "Key3" to 12,
                                "Key4" to 18,
                                // ... (add more key-value pairs as needed)
                            )

                            // Sort the HashMap by values in ascending order, excluding the first element
                            val sortedMap = originalMap.toList().drop(1).sortedBy { it.second }.toMap()

                            // Create the final sorted map with the first element
                            val resultMap = linkedMapOf(originalMap.toList().first()) + sortedMap

                            // Print the sorted map
                            resultMap.forEach { (key, value) ->
                                println("$key: $value")
                            }
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        //Dublicate element find

                        void main() {
                           List<String> list = ["Dante", "Mario", "Luigi", "Kratos", "Mario", "Dante"];

                          final counter = list.fold<Map<String, int>>({}, (duplicationMap, name) {
                            final count = duplicationMap[name] ?? 0;
                            duplicationMap[name] = count + 1;
                            return duplicationMap;
                          });
                          
                          print(counter);
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        main(){
                          String temp = 'Welcome';
                          String temp1 = 'welcome';

                          String temp2 = temp;
                          print(temp == temp2); //true
                          print(identical(temp2, temp)); //true

                          print(temp == temp); //true
                          print(temp == temp1); //false


                          print(identical(temp.toLowerCase(), temp.toLowerCase())); //false
                          print(identical(temp, temp)); //true
                          print(identical(temp, temp1)); //false
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        String dog(String str, [bool x = false]) {
                          var result = str.toUpperCase();
                          if (x) result = result + '!!!';
                          return result;
                        }

                        String cat(String str, {bool m = false}) {
                          var result = str.toLowerCase();
                          if (m) result = result + '....';

                          return result;
                        }

                        main() async {
                          print(dog('Hello, Flutter'));
                          print(dog('Hello, Flutter', true));
                          print(cat('Hello, Kotlin', m: true));
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        void main(){
                          var i = new Map();
                          i['id'] = 'flutter';
                          i['Pwd'] = 'flutter@123';
                          print(i);
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = $$"""
                        import 'dart:async';

                        main() async
                        {
                          await for(String msg in numberCount(3)){
                            print(msg);
                          }
                        }

                        Stream numberCount(int n) async*{
                          int k = n;
                          while(k >= 0){
                            yield await load(k--);
                          }
                        }

                        Future load(int i) async {
                          await new Future.delayed(Duration(microseconds: 50));
                          if(i % 2 == 0){
                            return '$i is even';
                          } else {
                            return '$i is odd';
                          }
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        import 'dart:async';

                        main(){
                          new Future(() => print('My'));
                          print('Programming');

                          scheduleMicrotask(() => print('is'));
                          print('Dart');
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = $$"""
                        import 'dart:async';

                        typedef arithmaticOperation(int a, int b);

                        Add (int a, int b){
                          print('Add result is ${a + b}');
                        }

                        Calculator(int a, int b, arithmaticOperation oper) {
                          print('Inside calculator');
                          oper(a, b);
                        }

                        void main(){
                          arithmaticOperation oper = Add;
                          oper(10, 20);
                          oper = Calculator(1, 2, oper);
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        class User {
                          String? name;

                          User(this.name);

                          User.copy(User original) {
                            this.name = original.name;
                          }
                        }

                        void main() {
                          var user1 = User('Alice');
                          var user2 = User.copy(user1); // Creating a separate copy
                          user2.name = 'Bob';
                          print(user1.name); // Output: Alice (No unexpected change)
                          print(user2.name);
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        void main(){
                          dynamic a = 10;

                          print(a is int);
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        import 'dart:async';

                        Future<int> addStream(Stream<int> stream) async{
                          var sum = 0;

                          await for(var value in stream){
                            sum += value;
                          }
                          return sum;
                        }

                        Stream<int> countStream(int to) async* {
                          for(int i=1; i<= to; i++){
                            yield i;
                          }
                        }

                        main() async{
                          var stream = countStream(34);
                          var sum = await addStream(stream);
                          print(sum);
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        void main() {
                          final list = [1, 2, 3];
                          for(var i in list){
                            list.remove(i);
                          }
                          print(list);
                        }
                        
                        //output: 2
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                    //Filter / Search using Riverpod
                        
                    final favProvider = StateNotifierProvider<FavNotifier, FavStates>((ref) {
                        return FavNotifier();
                    });
                    
                    class FavNotifier extends StateNotifier<FavStates> {
                        FavNotifier() : super(Favstates(allItems: [], favitems: [], search: "'));
                    }
                    
                    void addItems () {
                        List<Item> items = [
                            Item (name: 'Item 1', id: 1, favourite: true),
                            Item (name: 'Item 2', id: 2, favourite: false),
                        ];
                        state = state.copyWith(allItems: items, favItems: items);
                    }
                    
                    void filterList(String search) {
                        state = state.copyWith(
                                        favItems: state.allItems where( (item) → item.name. contains (search)). toList(),
                                );
                        }
                    }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        abstract class NetworkInfo {
                            Future<bool> isConnected();
                        }

                        class NetworkInfoImpl implements NetworkInfo {
                            final Connectivity _connectivity;

                            const NetworkInfoImpl({required Connectivity connectivity})
                                : _connectivity = connectivity;

                            @override
                            Future<bool> isConnected() async {
                                final connectivityResult = await _connectivity.checkConnectivity();
                                return connectivityResult.contains(ConnectivityResult.mobile) ||
                                    connectivityResult.contains(ConnectivityResult.wifi) ||
                                    connectivityResult.contains(ConnectivityResult.ethernet);
                            }
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        //Custom Outline InputBorder 
                        
                        import 'package:flutter/material.dart';

                        class CustomOutlineInputBorder extends InputBorder {
                          /// Creates an underline border for an [InputDecorator].
                          ///
                          /// The [borderSide] parameter defaults to [BorderSide.none] (it must not be
                          /// null). Applications typically do not specify a [borderSide] parameter
                          /// because the input decorator substitutes its own, using [copyWith], based
                          /// on the current theme and [InputDecorator.isFocused].
                          ///
                          /// The [borderRadius] parameter defaults to a value where the top left
                          /// and right corners have a circular radius of 4.0. The [borderRadius]
                          /// parameter must not be null.
                          const CustomOutlineInputBorder({
                            super.borderSide = const BorderSide(),
                            this.borderRadius = const BorderRadius.all(Radius.circular(4.0)),
                            this.gapPadding = 4.0,
                          })  : assert(gapPadding >= 0.0);

                          /// Horizontal padding on either side of the border's
                          /// [InputDecoration.labelText] width gap.
                          ///
                          /// This value is used by the [paint] method to compute the actual gap width.

                          final double gapPadding;

                          /// The radii of the border's rounded rectangle corners.
                          ///
                          /// When this border is used with a filled input decorator, see
                          /// [InputDecoration.filled], the border radius defines the shape
                          /// of the background fill as well as the bottom left and right
                          /// edges of the underline itself.
                          ///
                          /// By default the top right and top left corners have a circular radius
                          /// of 4.0.
                          final BorderRadius borderRadius;

                          @override
                          bool get isOutline => false;

                          @override
                          CustomOutlineInputBorder copyWith({
                            BorderSide? borderSide,
                            BorderRadius? borderRadius,
                            double? gapPadding,
                          }) {
                            return CustomOutlineInputBorder(
                              borderSide: borderSide ?? this.borderSide,
                              borderRadius: borderRadius ?? this.borderRadius,
                              gapPadding: gapPadding ?? this.gapPadding,
                            );
                          }

                          @override
                          EdgeInsetsGeometry get dimensions {
                            return EdgeInsets.only(bottom: borderSide.width);
                          }

                          @override
                          CustomOutlineInputBorder scale(double t) {
                            return CustomOutlineInputBorder(
                              borderSide: borderSide.scale(t),
                              borderRadius: borderRadius * t,
                              gapPadding: gapPadding * t,
                            );
                          }

                          @override
                          Path getInnerPath(Rect rect, {TextDirection? textDirection}) {
                            return Path()
                              ..addRRect(borderRadius
                                  .resolve(textDirection)
                                  .toRRect(rect)
                                  .deflate(borderSide.width));
                          }

                          @override
                          Path getOuterPath(Rect rect, {TextDirection? textDirection}) {
                            return Path()..addRRect(borderRadius.resolve(textDirection).toRRect(rect));
                          }

                          @override
                          ShapeBorder? lerpFrom(ShapeBorder? a, double t) {
                            if (a is CustomOutlineInputBorder) {
                              return CustomOutlineInputBorder(
                                borderSide: BorderSide.lerp(a.borderSide, borderSide, t),
                                borderRadius: BorderRadius.lerp(a.borderRadius, borderRadius, t)!,
                                gapPadding: a.gapPadding,
                              );
                            }
                            return super.lerpFrom(a, t);
                          }

                          @override
                          ShapeBorder? lerpTo(ShapeBorder? b, double t) {
                            if (b is CustomOutlineInputBorder) {
                              return CustomOutlineInputBorder(
                                borderSide: BorderSide.lerp(borderSide, b.borderSide, t),
                                borderRadius: BorderRadius.lerp(borderRadius, b.borderRadius, t)!,
                                gapPadding: b.gapPadding,
                              );
                            }
                            return super.lerpTo(b, t);
                          }
                          
                          /// Draw a horizontal line at the bottom of [rect].
                          ///
                          /// The [borderSide] defines the line's color and weight. The `textDirection`
                          /// `gap` and `textDirection` parameters are ignored.
                          @override
                          void paint(
                            Canvas canvas,
                            Rect rect, {
                            double? gapStart,
                            double gapExtent = 0.0,
                            double gapPercentage = 0.0,
                            TextDirection? textDirection,
                          }) {
                            final Paint paint = borderSide.toPaint();
                            final RRect outer = borderRadius.toRRect(rect);
                            final RRect center = outer.deflate(borderSide.width / 2.0);

                            canvas.drawRRect(center, paint);
                          }

                          @override
                          bool operator ==(Object other) {
                            if (identical(this, other)) return true;
                            if (other.runtimeType != runtimeType) return false;
                            return other is InputBorder && other.borderSide == borderSide;
                          }

                          @override
                          int get hashCode => borderSide.hashCode;
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        //Responsive Gridview
                        class GridBackground extends StatelessWidget {
                          const GridBackground({super.key});

                          @override
                          Widget build(BuildContext context) {
                            const double squareSize = 60.0;
                            const double gap = 6.0;

                            return LayoutBuilder(
                              builder: (context, constraints) {
                                final width = constraints.maxWidth;
                                final height = constraints.maxHeight;

                                final int columns = (width / (squareSize + gap)).floor();
                                final int rows = (height / (squareSize + gap)).floor();
                                final int itemCount = columns * rows;

                                return GridView.builder(
                                  physics: const NeverScrollableScrollPhysics(),
                                  padding: EdgeInsets.all(6),
                                  gridDelegate: SliverGridDelegateWithFixedCrossAxisCount(
                                    crossAxisCount: columns,
                                    crossAxisSpacing: gap,
                                    mainAxisSpacing: gap,
                                    childAspectRatio: 1.0
                                  ),
                                  itemCount: itemCount,
                                  itemBuilder: (context, index) {
                                    return const HoverSquare();
                                  }
                                );
                              }
                            );
                          }
                        }
                    """.trimIndent()
                )

                KotlinCode(
                    code = """
                        class TimeBlockOnBoard extends StatelessWidget {
                          final String title;
                          final String schedule;
                          final IconData icon;
                          final double transform;
                          final double angle;
                          final Color color;
                          
                          const TimeBlockOnBoard({
                            Key? key,
                            required this.title,
                            required this.schedule,
                            required this.icon,
                            required this.color,
                            this.transform = 0.0,
                            this.angle = 0.0,
                            
                          }) : super(key: key);

                          @override
                          Widget build(BuildContext context) {
                            return Container(
                              width: double.infinity,
                              margin: const EdgeInsets.only(bottom: 14),
                              padding: const EdgeInsets.symmetric(vertical: 22, horizontal: 20),
                              decoration: BoxDecoration(
                                color: const Color(0xFF1A2A3A),
                                borderRadius: BorderRadius.circular(16),
                              ),
                              child: Row(
                                children: [
                                  Container(
                                    width: 36,
                                    height: 36,
                                    decoration: const BoxDecoration(
                                      color: Color(0xFF2A3A4A),
                                      borderRadius: BorderRadius.all(Radius.circular(12)),
                                    ),
                                    child: Icon(
                                      icon,
                                      color: color,
                                      size: 18,
                                    ),
                                  ),
                                  const SizedBox(width: 16),
                                  Expanded(
                                    child: Column(
                                      crossAxisAlignment: CrossAxisAlignment.start,
                                      children: [
                                        Text(
                                          title,
                                          style: const TextStyle(
                                            color: Colors.white,
                                            fontSize: 16,
                                            fontWeight: FontWeight.w600,
                                          ),
                                        ),
                                        const SizedBox(height: 4),
                                        Text(
                                          schedule,
                                          style: TextStyle(
                                            color: Colors.white.withOpacity(0.7),
                                            fontSize: 12,
                                          ),
                                        ),
                                      ],
                                    ),
                                  ),
                                ],
                              ),
                            );
                          }
                        } 
                        
                        class OnboardDesign extends StatefulWidget {
                          const OnboardDesign({Key? key}) : super(key: key);

                          @override
                          State<OnboardDesign> createState() => _OnboardDesignState();
                        }

                        class _OnboardDesignState extends State<OnboardDesign> with SingleTickerProviderStateMixin {
                          late AnimationController _animationController;
                          late Animation<double> _animation1;
                          late Animation<double> _animation2;
                          late Animation<double> _animation3;
                          late Animation<double> _opacityAnimation;

                          @override
                          void initState() {
                            super.initState();
                            _animationController = AnimationController(
                              vsync: this,
                              duration: const Duration(milliseconds: 1200),
                            );
                            
                            _animation3 = TweenSequence<double>([
                              TweenSequenceItem(
                                tween: Tween<double>(begin: -200, end: 10).chain(CurveTween(curve: Curves.easeOutCubic)),
                                weight: 85,
                              ),
                              TweenSequenceItem(
                                tween: Tween<double>(begin: 5, end: 0).chain(CurveTween(curve: Curves.elasticOut)),
                                weight: 15,
                              ),
                            ]).animate(
                              CurvedAnimation(
                                parent: _animationController,
                                curve: const Interval(0.0, 0.6),
                              ),
                            );
                            
                            _animation2 = TweenSequence<double>([
                              TweenSequenceItem(
                                tween: Tween<double>(begin: -200, end: 10).chain(CurveTween(curve: Curves.easeOutCubic)),
                                weight: 85,
                              ),
                              TweenSequenceItem(
                                tween: Tween<double>(begin: 5, end: 0).chain(CurveTween(curve: Curves.elasticOut)),
                                weight: 15,
                              ),
                            ]).animate(
                              CurvedAnimation(
                                parent: _animationController,
                                curve: const Interval(0.2, 0.8),
                              ),
                            );
                            
                            _animation1 = TweenSequence<double>([
                              TweenSequenceItem(
                                tween: Tween<double>(begin: -200, end: 10).chain(CurveTween(curve: Curves.easeOutCubic)),
                                weight: 85,
                              ),
                              TweenSequenceItem(
                                tween: Tween<double>(begin: 5, end: 0).chain(CurveTween(curve: Curves.elasticOut)),
                                weight: 15,
                              ),
                            ]).animate(
                              CurvedAnimation(
                                parent: _animationController,
                                curve: const Interval(0.4, 1.0),
                              ),
                            );
                            
                            // Add opacity animation for description
                            _opacityAnimation = Tween<double>(
                              begin: 0.0,
                              end: 1.0,
                            ).animate(
                              CurvedAnimation(
                                parent: _animationController,
                                curve: const Interval(0.6, 1.0, curve: Curves.easeIn),
                              ),
                            );
                            
                            _animationController.forward();
                          }

                          @override
                          void dispose() {
                            _animationController.dispose();
                            super.dispose();
                          }

                          @override
                          Widget build(BuildContext context) {
                            return Scaffold(
                              backgroundColor: const Color(0xFF0A1A2A),
                              body: Stack(
                                children: [
                                  const CirclesOnboard(),
                                  
                                  // Content
                                  SafeArea(
                                    child: Padding(
                                      padding: const EdgeInsets.symmetric(horizontal: 24.0),
                                      child: Column(
                                        crossAxisAlignment: CrossAxisAlignment.start,
                                        children: [
                                          const Spacer(flex: 2),
                                          
                                          // First time block with animation
                                          Transform.translate(
                                            offset: Offset(-100, 0),
                                            child: AnimatedBuilder(
                                              animation: _animation1,
                                              builder: (context, child) {
                                                return Transform.translate(
                                                  offset: Offset(0, _animation1.value),
                                                  child: Transform.rotate(
                                                    angle: 0.3,
                                                    child: Opacity(
                                                      opacity: 0.5,
                                                      child: TimeBlockOnBoard(
                                                        title: "Deep Focus",
                                                        schedule: "Everyday, 9:00 AM - 12:00 PM",
                                                        icon: Icons.nightlight_round,
                                                        transform: 0.1,
                                                        color: Colors.white,
                                                        angle: 0.2,
                                                      ),
                                                    ),
                                                  ),
                                                );
                                              },
                                            ),
                                          ),
                                          
                                          const SizedBox(height: 8),
                                          
                                          // Second time block with animation
                                          Transform.translate(
                                            offset: Offset(130, 0),
                                            child: AnimatedBuilder(
                                              animation: _animation2,
                                              builder: (context, child) {
                                                return Transform.translate(
                                                  offset: Offset(0, _animation2.value),
                                                  child: Transform.rotate(
                                                    angle: -0.2,
                                                    child: Opacity(
                                                      opacity: 0.8,
                                                      child: TimeBlockOnBoard(
                                                        title: "Morning Time",
                                                        schedule: "Everyday, 6:00 AM - 8:00 AM",
                                                        icon: Icons.star,
                                                        color: Colors.yellow,
                                                        transform: -0.25,
                                                        angle: -0.2,
                                                      ),
                                                    ),
                                                  ),
                                                );
                                              },
                                            ),
                                          ),
                                          
                                          const SizedBox(height: 8),
                                          
                                          // Third time block with animation
                                          Transform.translate(
                                            offset: Offset(-60, 0),
                                            child: AnimatedBuilder(
                                              animation: _animation3,
                                              builder: (context, child) {
                                                return Transform.translate(
                                                  offset: Offset(0, _animation3.value),
                                                  child: Transform.rotate(
                                                    angle: 0.2,
                                                    child: TimeBlockOnBoard(
                                                      title: "Work Time",
                                                      schedule: "Mon-Fri, 9:00 AM - 5:00 PM",
                                                      icon: Icons.star,
                                                      color: Colors.redAccent,
                                                      transform: 0.1,
                                                      angle: 0.2,
                                                    ),
                                                  ),
                                                );
                                              },
                                            ),
                                          ),
                                          
                                          
                                          
                                          const Spacer(flex: 3),
                                          
                                          // Headline text
                                          AnimatedBuilder(animation: _animationController, builder: (context, child) {
                                            return Transform.translate(
                                              offset: Offset(0, _animationController.value),
                                              child: Opacity(
                                                opacity: _opacityAnimation.value,
                                                child: DescriptionOnBoard(),
                                              ),
                                            );
                                          }),

                                          const SizedBox(height: 42),
                                          
                                         // Get started button
                                          AnimatedBuilder(animation: _animationController, builder: (context, child) {
                                            return Transform.translate(
                                              offset: Offset(0, _animationController.value),
                                              child: Opacity(
                                                opacity: _opacityAnimation.value,
                                                child: GetStartedButton(),
                                              ),
                                            );
                                          }),
                                          const SizedBox(height: 24),
                                        ],
                                      ),
                                    ),
                                  ),
                                ],
                              ),
                            );
                          }
                        }
                    """.trimIndent()
                )
            }
        }
    }
}

//https://medium.com/@kamal.lakhani56/dart-interview-question-fe2ac7d65293

/*
Li(Modifier.padding(top = 1.em).toAttrs()) {
                    Column {
                        SpanText(
                            text = "",
                            modifier = Modifier.fontSize(FontSize.Large)
                                .fontWeight(FontWeight.Bold)
                        )

                        Ul {
                            Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                                SpanText(
                                    text = "",
                                    modifier = Modifier
                                        .fontSize(FontSize.Medium)
                                )
                            }
                        }
                    }
                }
*/

//https://pub.dev/packages/turnable_page
//https://pub.dev/packages/premium_otp_input (OTP)

//WEBSITE
//https://github.com/elkafrawyel/cv_web_app (https://freelancing-project-7ed76.web.app)
//https://github.com/AsemAmmar99/my_portfolio
//https://github.com/JOELPSHAJU/Portfolio-.git
//https://github.com/johnkpoghomou-lab/mon_portofolio
//https://github.com/OwaisRaza1941/My-Portfolio

//https://www.linkedin.com/in/amirhossein-bayat-9288a4225/ (BottomBar Animation Liquid)
//https://pub.dev/packages/sliding_indicator_listview
//https://github.com/jigarfumakiya/flutter-animation-showcase (Detail Page Animation)
//https://github.com/hyperiontechllc/thermo_lava

/*
Always call WidgetsFlutterBinding.ensureInitialized() before using platform channels, plugins, disk access, or SystemChrome. Errors thrown in main() can crash the app before UI exists, so use runZonedGuarded() for a top-level error boundary.
*/